var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentHighlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83333 2.16683H16.5M9.83333 5.50016H14M9.83333 10.5002H16.5M9.83333 13.8335H14M1.5 2.16683C1.5 1.94582 1.5878 1.73385 1.74408 1.57757C1.90036 1.42129 2.11232 1.3335 2.33333 1.3335H5.66667C5.88768 1.3335 6.09964 1.42129 6.25592 1.57757C6.4122 1.73385 6.5 1.94582 6.5 2.16683V5.50016C6.5 5.72118 6.4122 5.93314 6.25592 6.08942C6.09964 6.2457 5.88768 6.3335 5.66667 6.3335H2.33333C2.11232 6.3335 1.90036 6.2457 1.74408 6.08942C1.5878 5.93314 1.5 5.72118 1.5 5.50016V2.16683ZM1.5 10.5002C1.5 10.2791 1.5878 10.0672 1.74408 9.91091C1.90036 9.75463 2.11232 9.66683 2.33333 9.66683H5.66667C5.88768 9.66683 6.09964 9.75463 6.25592 9.91091C6.4122 10.0672 6.5 10.2791 6.5 10.5002V13.8335C6.5 14.0545 6.4122 14.2665 6.25592 14.4228C6.09964 14.579 5.88768 14.6668 5.66667 14.6668H2.33333C2.11232 14.6668 1.90036 14.579 1.74408 14.4228C1.5878 14.2665 1.5 14.0545 1.5 13.8335V10.5002Z",
    stroke: "#DCDCEC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentHighlights);
export default __webpack_public_path__ + "static/media/investment_highlights.69a4c2bd97cec0a43693ffa3d1369405.svg";
export { ForwardRef as ReactComponent };